import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useTestId from '@ori/testid-generator';
import { Pbs as PbsWaveIcon, Products } from '@ori-ui/icons';
import { Avatar, Box, Link, styled, useTheme } from '@ori-ui/mui';
import { LiveStreamingStateWrap } from "../common/LiveStreamingStateWrap";
import { useTranslation } from "../../hooks";
import { LiveStreamingStates, MenuItemTestIds, TranslationKeys } from "../../models";

/**
 * Avatar size. Value is in pixels
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AVATAR_SIZE = 28;
export var StyledAvatar = styled(Avatar)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[900]
  };
});
export var StyledProducts = styled(Products)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    width: 22,
    height: 24,
    margin: theme.spacing(1.4, 0.6)
  };
});
export var LinkWrap = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2)
  };
});
var Root = styled(Box)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    marginTop: theme.spacing(6)
  };
});
var PersonalLink = styled(Link)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.palette.common.black,
    textDecoration: 'underline',
    fontWeight: 'bold',
    fontSize: 14 /*  theme.typography.pxToRem(14) this seems to return 1.4 rem instead of 0.875 rem */
  };
});

var getLiveStreamingLabel = function getLiveStreamingLabel(liveStreamingState) {
  switch (liveStreamingState) {
    case LiveStreamingStates.IS_LIVE:
      return TranslationKeys.LiveNow;
    case LiveStreamingStates.PLANNED:
      return TranslationKeys.LiveVideoStartingSoon;
    default:
      return TranslationKeys.WatchLatestVideo;
  }
};
export var MenuItemPersonalLinks = function MenuItemPersonalLinks(_ref6) {
  var personalProductListConfiguration = _ref6.personalProductListConfiguration,
    videoShoppingConfiguration = _ref6.videoShoppingConfiguration,
    liveStreamingState = _ref6.liveStreamingState,
    photoUrl = _ref6.photoUrl;
  var theme = useTheme();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useTestId = useTestId(),
    getTestIdProps = _useTestId.getTestIdProps;
  return /*#__PURE__*/_jsxs(Root, {
    children: [personalProductListConfiguration !== null && personalProductListConfiguration !== void 0 && personalProductListConfiguration.isEnabled && personalProductListConfiguration.sharedUrl ? /*#__PURE__*/_jsxs(LinkWrap, {
      sx: {
        marginTop: theme.spacing(3.75)
      },
      children: [/*#__PURE__*/_jsx(StyledProducts, {
        viewBox: "2.8 4 16.5 16"
      }), /*#__PURE__*/_jsx(PersonalLink, _objectSpread(_objectSpread({
        href: personalProductListConfiguration.sharedUrl
      }, getTestIdProps(MenuItemTestIds.RECOMMENDED_PRODUCTS)), {}, {
        children: t(TranslationKeys.SeeMyFavoriteProducts)
      }))]
    }) : null, videoShoppingConfiguration !== null && videoShoppingConfiguration !== void 0 && videoShoppingConfiguration.isEnabled && videoShoppingConfiguration.sharedUrl ? /*#__PURE__*/_jsxs(LinkWrap, {
      sx: {
        marginTop: theme.spacing(3.75)
      },
      children: [/*#__PURE__*/_jsx(LiveStreamingStateWrap, {
        streamingActivity: liveStreamingState !== null && liveStreamingState !== void 0 ? liveStreamingState : LiveStreamingStates.UNKNOWN,
        children: /*#__PURE__*/_jsx(StyledAvatar, _objectSpread(_objectSpread({
          src: photoUrl !== null && photoUrl !== void 0 ? photoUrl : '',
          alt: t(TranslationKeys.SponsorPhoto)
        }, getTestIdProps(MenuItemTestIds.AVATAR)), {}, {
          children: /*#__PURE__*/_jsx(PbsWaveIcon, _objectSpread({
            sx: {
              width: 22,
              height: 24
            },
            viewBox: "2.8 4 16.5 16"
          }, getTestIdProps(MenuItemTestIds.FALLBACK_AVATAR)))
        }))
      }), /*#__PURE__*/_jsx(PersonalLink, _objectSpread(_objectSpread({
        href: videoShoppingConfiguration.sharedUrl
      }, getTestIdProps(MenuItemTestIds.WATCH_LATEST_VIDEO)), {}, {
        children: t(getLiveStreamingLabel(liveStreamingState !== null && liveStreamingState !== void 0 ? liveStreamingState : LiveStreamingStates.UNKNOWN))
      }))]
    }) : null]
  });
};